import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import Checkbox from '../../../../components/forms/Checkbox'
import { INSTALLATION_ORIGIN, INSTALLATION_TYPE } from '../../../constants/InstallationConstants'
import { i18nize } from '../../../../utils/StringUtil'
import { arrayOf } from '../../../../utils/StoreUtils'
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux'
import DtoInstallationType from '../../../dto/installation/DtoInstallationType'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import DtoInstallationActivity from '../../../dto/industrialSite/DtoInstallationActivity'
import { getStatusesWithNoStatus } from '../../../../utils/QualityUtils'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import DtoSandreCode from '../../../../referencial/dto/DtoSandreCode'
import { isUndefined, uniq } from 'lodash'
import DtoFilter from 'station/dto/DtoFilter'
import StationAction from 'station/actions/StationAction'
import { hasValue } from 'utils/NumberUtil'
import FilterInsertModal from 'components/modal/FilterInsertModal'
import DtoUserBookmark from 'administration/components/user/dto/DtoUserBookmark'
import UserAction from 'administration/components/user/actions/UserAction'
import { Button, CardContent, Grid, Card, Icon } from '@mui/material'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import DtoNetwork from 'station/dto/DtoNetwork'
import ContributorItem from 'referencial/components/contributor/dto/ContributorItem'
import DtoContributorLink from 'station/dto/DtoContributorLink'
import SieauParameterDto from 'administration/dto/SieauParameterDto'
import { isAepInstallation } from 'utils/InstallationUtils'
import { DEFAULT_CONTRIBUTOR_TYPE, FILTER_TYPE } from 'administration/components/user/constants/UserConstants'
import SimpleFilterSelect from 'components/forms/specific/SimpleFilterSelect'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'
import InstallationAction from 'installation/actions/InstallationAction'
import DtoInstallation from 'installation/dto/installation/DtoInstallation'
import User from 'account/dto/User'
import useSandreList from 'utils/customHook/useSandreList'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const InstallationsFilterForm = ({
    defaultFilter,
    onValidate,
    contributorLinks,
}) => {
    const dispatch = useDispatch()

    const [isOpen, setIsOpen] = useState(false)
    const [isOpenValidate, setIsOpenValidate] = useState(false)
    const [filter, setFilter] = useState(defaultFilter)

    const {
        installationsTypes,
        cities,
        activities,
        filters,
        userBookmarks,
        contributorsIndex,
        installations,
        accountUser,
    } = useSelector(store => ({
        installationsTypes: store.InstallationReducer.installationsTypes,
        cities: store.CityReducer.cities,
        activities: store.InstallationReducer.activities,
        filters: store.StationReducer.filters,
        userBookmarks: store.UserReducer.userBookmarks,
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        installations: store.InstallationReducer.installationsLight,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    useEffect(() => {
        if (!filters.length) {
            dispatch(StationAction.fetchFilters())
        }
        if (!userBookmarks.length) {
            dispatch(UserAction.fetchBookmarks())
        }
        if (!installations.length) {
            dispatch(InstallationAction.fetchInstallationsLight())
        }
    }, [])

    const onChangeValue = (value) => setFilter(prev => ({ ...prev, ...value }))

    const usages = useSandreList(SANDRE.USAGES)
    const categories = useSandreList(SANDRE.ACTIVITES_CATEGORIE)
    const effectives = useSandreList(SANDRE.SITE_INDUS_EFFECTIF)

    const getSpecificFilters = () => {
        switch (filter.installationType) {
            case INSTALLATION_TYPE.INDUSTRIAL_SITE:
                return (
                    <>
                        <Grid size={2}>
                            <Select
                                label={i18n.activities}
                                options={activities}
                                value={filter.activity}
                                onChange={(v) => onChangeValue({ activity: v })}
                            />
                        </Grid>
                        <Grid size={2}>
                            <Select
                                label={i18n.effectiveTranche}
                                options={effectives}
                                value={filter.effectiveTranche}
                                onChange={(v) => onChangeValue({ effectiveTranche: v })}
                            />
                        </Grid>
                        <Grid size={2}>
                            <Select
                                label={i18n.category}
                                options={categories}
                                value={filter.category}
                                onChange={(v) => onChangeValue({ category: v })}
                            />
                        </Grid>
                        <Grid size={4}/>
                        <Grid size={2}>
                            <Checkbox
                                label={i18n.icpe}
                                checked={filter.ICPE}
                                onChange={(v) => onChangeValue({ ICPE: v })}
                                componentClassName='padding-top-1'
                            />
                        </Grid>
                        <Grid size={2}>
                            <Checkbox
                                label={i18n.seveso}
                                checked={filter.seveso}
                                onChange={(v) => onChangeValue({ seveso: v })}
                                componentClassName='padding-top-1'
                            />
                        </Grid>
                        <Grid size={2}>
                            <Checkbox
                                label={i18n.activeEstablishments}
                                checked={filter.inActivity}
                                onChange={(v) => onChangeValue({ inActivity: v })}
                                componentClassName='padding-top-1'
                            />
                        </Grid>
                        <Grid size={2} >
                            <Checkbox
                                label={i18n.dischargeAgreement}
                                checked={filter.dischargeAgreement}
                                onChange={(v) => onChangeValue({ dischargeAgreement: v })}
                                componentClassName='padding-top-1'
                            />
                        </Grid>
                        <Grid size={2}/>
                    </>
                )
            case INSTALLATION_TYPE.BOREHOLE:
                return (
                    <>
                        <Grid size={2}>
                            <Select
                                label={i18n.control}
                                options={getStatusesWithNoStatus()}
                                value={filter.status}
                                keyvalue='code'
                                nullLabel='&nbsp;'
                                onChange={(v) => onChangeValue({ status: v })}
                                integerValue
                            />
                        </Grid>
                        <Grid size={2} >
                            <Select
                                label={i18n.origin}
                                options={i18nize(INSTALLATION_ORIGIN.LIST)}
                                value={filter.dataOrigin}
                                keyvalue='code'
                                keyLabel='label'
                                nullLabel='&nbsp;'
                                onChange={(v) => onChangeValue({ dataOrigin: v })}
                                integerValue
                            />
                        </Grid>
                        <Grid size={2} >
                            <Select
                                label={i18n.usage}
                                options={usages}
                                value={filter.usage}
                                keyvalue='code'
                                keyLabel='name'
                                nullLabel='&nbsp;'
                                onChange={(v) => onChangeValue({ usage: v })}
                                integerValue
                            />
                        </Grid>
                        <Grid size={2} >
                            <Checkbox
                                label={i18n.withoutId}
                                checked={filter.withoutCode}
                                onChange={(v) => onChangeValue({ withoutCode: v })}
                                componentClassName='padding-top-1'
                            />
                        </Grid>
                    </>
                )
            default:
                return (
                    <>
                        <Grid size={2}>
                            <Select
                                label={i18n.control}
                                options={getStatusesWithNoStatus()}
                                value={filter.status}
                                keyvalue='code'
                                nullLabel='&nbsp;'
                                onChange={(v) => onChangeValue({ status: v })}
                                integerValue
                            />
                        </Grid>
                        <Grid size={2} >
                            <Select
                                label={i18n.origin}
                                options={i18nize(INSTALLATION_ORIGIN.LIST)}
                                value={filter.dataOrigin}
                                keyvalue='code'
                                keyLabel='label'
                                nullLabel='&nbsp;'
                                onChange={(v) => onChangeValue({ dataOrigin: v })}
                                integerValue
                            />
                        </Grid>
                        <Grid size={2}>
                            <Checkbox
                                label={ i18n.withoutId }
                                checked={ filter.withoutCode }
                                onChange={(v) => onChangeValue({ withoutCode: v })}
                                componentClassName='padding-top-1'
                            />
                        </Grid>
                        <Grid size={2}/>
                    </>
                )
        }
    }

    const operatorType = useApplicationSetting('contributorTypeOperator', setting => setting ? parseInt(setting) : DEFAULT_CONTRIBUTOR_TYPE.OPERATOR)
    const referentType = useApplicationSetting('contributorTypeAdministrator', setting => setting ? parseInt(setting) : DEFAULT_CONTRIBUTOR_TYPE.ADMINISTRATOR)

    const installReferents = !isUndefined(contributorLinks) ? uniq(contributorLinks
        .filter(c => c.contributorType === referentType).map(l => l.idContributor))
        .map(id => contributorsIndex[id])
        .filter(c => !isUndefined(c)) : []

    const installOperators = !isUndefined(contributorLinks) ? uniq(contributorLinks
        .filter(c => c.contributorType === operatorType).map(l => l.idContributor))
        .map(id => contributorsIndex[id])
        .filter(c => !isUndefined(c)) : []

    return (
        <>
            <Card>
                <CardContent>
                    <Grid container rowSpacing={1} columnSpacing={2} padding={1}>
                        <Grid container columnSpacing={2} size={12}>
                            <Grid size={2} >
                                <Input
                                    title={i18n.search}
                                    value={filter.searchValue}
                                    onChange={(v) => onChangeValue({ searchValue: v })}
                                    onEnterKeyPress={(v) => {
                                        onChangeValue({ searchValue: v })
                                        onValidate(filter)
                                    }}
                                />
                            </Grid>
                            <Grid container size={2}>
                                <Grid size={10}>
                                    <SimpleFilterSelect
                                        stations={installations}
                                        stationType={STATION_TYPE_CONSTANT.INSTALLATION}
                                        onChange={(_, newFilter) => {
                                            onChangeValue({ selectedFilter: newFilter })
                                        }}
                                        isValidateOpen={isOpenValidate}
                                        setIsOpenValidate={v => setIsOpenValidate(v)}
                                    />
                                </Grid>
                                <Grid container alignItems='center' size={2}>
                                    {accountUser.isAdmin === '1' && (
                                        <Icon id='add_filter_icon' onClick={() => setIsOpen(true)} sx={{ paddingTop: '3px' }}>
                                            {hasValue(filter.selectedFilter) && filter.selectedFilter !== FILTER_TYPE.BOOKMARK && filter.selectedFilter !== FILTER_TYPE.NOFILTER ? 'edit' : 'note_add'}
                                        </Icon>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid size={2}>
                                <Select
                                    label={i18n.city}
                                    options={cities}
                                    value={filter.city}
                                    keyLabel='labelWithCode'
                                    onChange={(v) => onChangeValue({ city: v })}
                                />
                            </Grid>
                            {(!hasValue(filter.installationType) || isAepInstallation(filter.installationType)) && !!installReferents.length && (
                                <Grid size={2}>
                                    <MultiContributorsAutocomplete
                                        label={i18n.buildingOwnerName}
                                        options={installReferents}
                                        onChange={(v) => onChangeValue({ referentIds: v })}
                                        keyValue='code'
                                        multiple
                                    />
                                </Grid>
                            )}
                            {(!hasValue(filter.installationType) || isAepInstallation(filter.installationType)) && !!installOperators.length && (
                                <Grid size={2}>
                                    <MultiContributorsAutocomplete
                                        label={i18n.operator}
                                        options={installOperators}
                                        onChange={(v) => onChangeValue({ operatorIds: v })}
                                        keyValue='code'
                                        multiple
                                    />
                                </Grid>
                            )}
                        </Grid>
                        <Grid size={2}>
                            <Select
                                label={i18n.type}
                                options={installationsTypes.filter(it => it.display)}
                                value={filter.installationType}
                                keyvalue='id'
                                nullLabel='&nbsp;'
                                onChange={(t) => onChangeValue({ installationType: t })}
                                integerValue
                            />
                        </Grid>
                        {getSpecificFilters()}
                        <Grid size={2}>
                            <Button
                                variant='contained'
                                fullWidth
                                onClick={() => onValidate(filter)}
                            >
                                {i18n.search}
                            </Button>
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>
            <FilterInsertModal
                setOpen={op => setIsOpen(op)}
                open={isOpen}
                selectedFilter={filter.selectedFilter}
                module='INST'
                isNew={!hasValue(filter.selectedFilter) || filter.selectedFilter === FILTER_TYPE.BOOKMARK || filter.selectedFilter === FILTER_TYPE.NOFILTER}
                onChange={(v) => onChangeValue({ selectedFilter: v })}
            />
        </>
    )
}

InstallationsFilterForm.propTypes = {
    onValidate: PropTypes.func,
    onChangePanel: PropTypes.func,
    defaultFilter: PropTypes.shape({
        city: PropTypes.string,
        dataOrigin: PropTypes.number,
        forceLoa: PropTypes.bool,
        referentIds: PropTypes.arrayOf(PropTypes.number),
        operatorIds: PropTypes.arrayOf(PropTypes.number),
        installationType: PropTypes.number,
        module: PropTypes.string,
        searchValue: PropTypes.string,
        selectedFilter: PropTypes.number,
        status: PropTypes.number,
        withoutCode: PropTypes.bool,
    }),
    panel: PropTypes.string,
    activities: arrayOf(DtoInstallationActivity),
    installationsTypes: arrayOf(DtoInstallationType),
    cities: arrayOf(CityDto),
    sandreCodes: arrayOf(DtoSandreCode),
    filters: arrayOf(DtoFilter),
    fetchFilters: PropTypes.func,
    userBookmarks: arrayOf(DtoUserBookmark),
    fetchBookmarks: PropTypes.func,
    networklist: PropTypes.arrayOf(PropTypes.instanceOf(DtoNetwork)),
    contributorLinks: PropTypes.arrayOf(PropTypes.instanceOf(DtoContributorLink)),
    contributorsIndex: PropTypes.arrayOf(PropTypes.instanceOf(ContributorItem)),
    settings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    installations: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
    fetchInstallations: PropTypes.func,
    accountUser: PropTypes.instanceOf(User),
}
const mapStateToProps = store => ({
    installationsTypes: store.InstallationReducer.installationsTypes,
    cities: store.CityReducer.cities,
    activities: store.InstallationReducer.activities,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    filters: store.StationReducer.filters,
    userBookmarks: store.UserReducer.userBookmarks,
    settings: store.AdministrationReducer.applicationSettings,
    contributorsIndex: store.ContributorReducer.contributorsIndex,
    installations: store.InstallationReducer.installationsLight,
    accountUser: store.AccountReducer.accountUser,
})

const mapDispatchToProps = {
    fetchFilters: StationAction.fetchFilters,
    fetchBookmarks: UserAction.fetchBookmarks,
    fetchInstallations: InstallationAction.fetchInstallationsLight,
}

export default connect(mapStateToProps, mapDispatchToProps)(InstallationsFilterForm)
